module.exports = __webpack_public_path__ + "static/img/account_icon7.bd8df8d9.png";